// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1E_Zh","paymentContainer":"PaymentPage_paymentContainer__1tRvf"};